import { Media } from '@pixacare/domain';
import { defer, map, Observable, switchMap } from 'rxjs';
import { blobToFile } from '@shared/utils/utils';

// TODO(cross-sequence-medias): remove this helper when the backend supports attaching an existing
// Media to a different wound. Today the API only creates new medias from File uploads, so any
// media picked from another sequence has to be re-uploaded as a File to be attached.
export const cloneMediaAsFile = (media: Media): Observable<File> =>
  defer(() => fetch(media.uri)).pipe(
    switchMap((response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch media ${media.id}: ${response.status}`);
      }
      return response.blob();
    }),
    map((blob) => blobToFile(blob, `m${media.id}-${media.originalFilename ?? media.filename ?? 'media'}`)),
  );
